<script>
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import ApplicationState from "../../../Stores/applicationStates"
  import notify from "../../../Script/notify"
  import PasscodeForm from "./Components/passcodeForm.svelte"
  import EmailForm from "./Components/emailForm.svelte"
  import NdAnoticeForm from "./Components/NDAnoticeForm.svelte"
  import ExpiryForm from "./Components/ExpiryForm.svelte"
  import TrustUrlCard from "./Components/trustURLCard.svelte"
  import DublicateUrl from "./Components/DublicateURL.svelte"
  import Table from "../../../Shared/TableWithoutApi/index.svelte"
  import FilterComponent from "./Components/filterComponent.svelte"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../Script/queryString"
  import ConfirmationModal from "../../Publish/BulkUpload/Shared/confirmationModal.svelte"
  import { getRequest, postRequest } from "../../../Script/apiMethods"

  /**
   * @type {Sring} - it's store the confirm passcode value. It must be same as passcode
   */
  let confirmPasscode = ""
  /**
   * @type {Sring} - it's store the passcode value
   */
  let passcode = ""

  /**
   * @type {Sring} - it's store the email domain value
   */
  let domineName = ""

  /**
   * @type {Sring} - it's store the entered email value
   */
  let givenEmail = ""

  /**
   * @type {Object} - it's store the NDA and notice url value
   */
  let Url = {
    NDA: "",
    notice: "",
  }
  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = false

  /**
   * @type {Array} - secured URLs are stored this variable
   */
  let duplicateURLs = []

  /**
   * @type {String || Array} - user filled email list or email domain stored this variable
   */
  let emailDomineOrList

  /**
   * @type {String} - which tab need to show
   */
  let activeTab = "Alias"

  /**
   * @typedef {Object} json - respective dosument details stored this variable
   * @type {Object}
   * respective dosument details stored this variable
   *
   * @property {String} documentID - selected document id's
   * @property {String} passcode - selected document id's secure URL's passcode
   * @property {String} emailDomain - selected document id's secure URL's email domain
   * @property {Array} emailList - selected document id's secure URL's email list
   * @property {String} nda - selected document id's secure URL's NDA url
   * @property {String} notice - selected document id's secure URL's notice URL
   * @property {String} expireOn - selected document id's secure URL's expiry date
   */

  /**
   * @type {json} - respective dosument details stored this variable
   */
  let json = {
    documentID: query.id,
  }

  /**
   * @type {aliasNotify}
   */
  let aliasNotify = {
    close() {},
  }

  let showConfirmationModal = false

  const validateDetails = () => {
    try {
      if (passcode || confirmPasscode) {
        if (!passcode) throw "Please enter the passcode field"
        if (!confirmPasscode) throw "Please enter the confirm passcode field"
        if (passcode && confirmPasscode) {
          if (passcode.length < 5 || confirmPasscode.length < 5) throw "Given passcode length must be minimum 5 character"
          else if (passcode != confirmPasscode) throw "Given passcode doesn't match"
        }
      }

      if (givenEmail) throw "Kindly include the email address that you Entered"

      if (domineName) {
        const DOMAIN_PATTERN = /^[A-Z0-9-]+(?:\.[A-Z0-9-]+)$/i
        if (!DOMAIN_PATTERN.test(domineName.trim())) throw "Enter Valid domain name. example (gmail.com)"
      }

      if (Url.NDA || Url.notice) {
        let regex = /^(https:\/\/|#|http:\/\/)/
        if (Url.NDA ? !regex.test(Url.NDA) : !regex.test(Url.notice)) throw "Identified an invalid URL, please rectify or remove it."
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * @description function for create secured URL.
   */
  const createAlias = async () => {
    try {
      aliasNotify.close()

      validateDetails()

      if (typeof emailDomineOrList == "string") json.emailDomain = emailDomineOrList
      else if (typeof emailDomineOrList == "object") json.emailList = emailDomineOrList

      apiCallBtnDisable = true

      await postRequest(`/api/swagger/v2/links`, json, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      await duplicateURLTab()

      json = {
        documentID: query.id,
      }

      aliasNotify = notify.success("New Alias URL created")
    } catch (error) {
      // Show an error notification
      const info = "PAGE: Secure Access\nEVENT: While Creating Secure Access (ALIAS) URL"
      aliasNotify = notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description function for fetch serued URL.
   */
  const duplicateURLTab = async () => {
    try {
      apiCallBtnDisable = true

      // Fetching document template by ID
      const { links } = await getRequest(`/api/swagger/v2/links?documentID=${json.documentID}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      duplicateURLs = links

      emailDomineOrList = ""
      confirmPasscode = ""
      domineName = ""
      passcode = ""
      Url.NDA = ""
      Url.notice = ""
      activeTab = "UrlList"
    } catch (error) {
      // Show an error notification
      aliasNotify.close()
      const info = "PAGE: Secure Access\nEVENT: While Fetching Secure Access (ALIAS) URL List"
      aliasNotify = notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }
</script>

<svelte:head>
  <title>Secure Access</title>
</svelte:head>

{#if apiCallBtnDisable}
  <LoadingScreen msg="Generating Alias URL" />
{/if}

{#if showConfirmationModal}
  <ConfirmationModal
    title="Confirmation"
    content="Since no access methods were applied to secure the URL, it will remain unsecured. Please confirm if you would like to proceed with creating the URL without secure access."
    on:click={() => {
      showConfirmationModal = false
    }}
    on:confirm={() => {
      showConfirmationModal = false
      createAlias()
    }}
  />
{/if}

<div class="relative h-full min-h-screen overflow-x-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class=" px-6">
    <div class="mx-auto w-full max-w-[920px] space-y-3 pb-32 pt-6">
      <div class="relative min-h-[530px] rounded-md bg-white dark:bg-mdGray">
        <div class="flex select-none gap-3 border-b border-[#d9d9d9] px-6 pt-1 dark:rounded-t-md dark:border-none dark:bg-zinc-900 dark:shadow-lg mobile:px-12 md:px-24">
          <button on:click={() => (activeTab = "Alias")} class="flex items-center text-xs md:text-sm {activeTab == 'Alias' ? ' border-[#ff6a00] text-[#ff6a00]' : 'border-transparent hover:text-[#ff6a00] dark:text-gray-200 hover:dark:text-[#ff6a00]'} border-b-2 px-2 py-2 font-semibold">
            <i class="fa-solid fa-file-shield" />
            <span>&nbsp;&nbsp;Secure Access</span>
            <!-- <span class="block mobile:hidden">&nbsp;&nbsp;Trustable URL</span> -->
          </button>
          <button on:click={duplicateURLTab} class="flex items-center text-xs md:text-sm {activeTab == 'UrlList' ? 'border-[#ff6a00] text-[#ff6a00]' : 'border-transparent hover:text-[#ff6a00] dark:text-gray-200 hover:dark:text-[#ff6a00]'} border-b-2 px-2 py-2 font-semibold">
            <i class="fa-solid fa-file-invoice" />
            <span>&nbsp;&nbsp;Alias URL List</span>
            <!-- <span class="block mobile:hidden">&nbsp;&nbsp;Alias URL</span> -->
          </button>
        </div>
        {#if activeTab == "Alias"}
          <div>
            <TrustUrlCard />
            <div class="space-y-3 px-6 pb-6 mobile:px-12">
              <h1 class="select-none text-lg font-bold dark:text-white">Secure Access</h1>
              <!-- accordian 1 -->
              <PasscodeForm bind:confirmPasscode bind:passcode on:output={(e) => (json.passcode = e.detail)} />

              <!-- accordian 2 -->
              <EmailForm
                bind:domineName
                bind:givenEmail
                on:output={(e) => {
                  emailDomineOrList = e.detail
                }}
              />

              <!-- accordian 3 -->
              <NdAnoticeForm
                bind:Url
                on:output={() => {
                  json.nda = Url.NDA
                  json.notice = Url.notice
                }}
              />

              <!-- accordian 1 -->
              <ExpiryForm
                on:output={(e) => {
                  json.expireOn = e.detail
                }}
              />
              <div class="pt-3">
                <button
                  on:click={() => {
                    try {
                      validateDetails()
                      if (Object.keys(json).length == 1 && !emailDomineOrList) showConfirmationModal = true
                      else createAlias()
                    } catch (error) {
                      const info = "PAGE: Secure Access\nEVENT: While validating Secure Access Details before ALIAS URL creation."
                      notify.danger(error, info)
                    }
                  }}
                  class="mx-auto flex h-9 w-auto min-w-[36px] select-none items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 lg:px-4"
                >
                  <i class="fa-solid fa-plus" />
                  &nbsp;&nbsp;Create Alias URL
                </button>
              </div>
            </div>
          </div>
        {:else}
          <div class="p-6 mobile:p-12">
            <Table list={DublicateUrl} filterComponent={FilterComponent} jsonData={duplicateURLs} title={"Alias URL"} filter={true} search={false} nameSort={false} />
          </div>
        {/if}
      </div>
    </div>
  </div>
  <Footer />
</div>
